<template>
  <div id="app" class="brand-app">
    <w-loading bg-color="rgba(255,255,255,0.8)" text="正在加载..." :is-show="getShowLoading" color="#00a0f3" :font-size="14" :spinner-width="30"
      :spinner-height="30" :spinner-type="6"></w-loading>
    <transition :name="transitionName">
      <router-view class="child-view"></router-view>
    </transition>
  </div>
</template>

<script>
  const history = window.sessionStorage;
  import {
    mapGetters
  } from 'vuex';
  import wui from 'wui';

  export default {
    name: 'app',
    data() {
      return {
        transitionName: 'slide-left'
      }
    },
    watch: {
      '$route' (to, from) {
        const toIndex = history.getItem(to.path);
        const fromIndex = history.getItem(from.path);
        this.transitionName = toIndex < fromIndex ? 'slide-right' : 'slide-left';
      }
    },
    computed: {
      ...mapGetters([
        'getShowLoading'
      ])
    }
  }
</script>

<style>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .5s ease;
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0
  }

  .child-view {
    position: absolute;
    transition: all .5s cubic-bezier(.55, 0, .1, 1);
  }

  .slide-left-enter,
  .slide-right-leave-active {
    opacity: 0;
    -webkit-transform: translate(30px, 0);
    transform: translate(30px, 0);
  }

  .slide-left-leave-active,
  .slide-right-enter {
    opacity: 0;
    -webkit-transform: translate(-30px, 0);
    transform: translate(-30px, 0);
  }

  #app {
    height: 100%;
  }
</style>


// WEBPACK FOOTER //
// app.vue?e0714f38